import RouteNameEnum from '@/router/RouteNameEnum';
import { FunnelStep } from '../FunnelStep';
import store from '@/store/BookingStore';
import { BookingFunnelService } from '@/service/BookingFunnelService/BookingFunnelService';
import getQueryParams from '@/utils/getQueryParams'
import { createRequestData } from '@/logic/createRequestParams';
import { Booking, StatusV2 } from '../../../../../requests-module/src';
import { startGlobalPollingFlight } from '@/composables/pollingFlightController';
import checkIsPackageFlight from '@/logic/options/checkIsPackageFlight';
import { applySingleCompanyConfigOnOptionsInit } from '@/logic/options/applySingleCompanyConfigOnOptionsInit';
import { prefillParticipantsFromLocalStorage } from '@/logic/participants/prefillParticipantsFromLocalStorage';
import {
    saveUrlTokenMapping,
    tryRestoreTokenFromUrlCache,
} from '@/logic/bookingFunnel/bookingFunnelUrlTokenCache';

export const optionsStep = new FunnelStep({
    name: RouteNameEnum.OptionsV2,
    dependencies: [],
    init: async () => {
        const queryParams = getQueryParams()

        let response: Booking | { error: string } | null = null

        if (!store.getters.getToken) {

            if (queryParams.origin) {
                if (queryParams.origin === 'STP' || queryParams.prest_id === 'TNE') {
                    return '/train'
                }
                // no bo yet was created redirect to flight
                return '/flight'
            }

            const restored = tryRestoreTokenFromUrlCache()
            if (restored) {
                console.log('init(): Options Page - restored BO from URL cache, refresh instead of init');
                response = await BookingFunnelService.refreshBookingOptions()
                if ('error' in response) {
                    throw new Error('Error with api')
                }
                saveUrlTokenMapping(window.location.href, response.boReference)

                if (checkIsPackageFlight(store.getters.getBooking)) {
                    startGlobalPollingFlight(store.getters.getBooking.boReference);
                }
                if (response.status == StatusV2.PROCESSING) {
                    return '/payment'
                }
                if (response.status == StatusV2.SUCCESS) {
                    return '/paid'
                }
            } else {
                console.log('init(): Initializing Option Page - depending on the package, make an init call to get BO with defaults');
                // no bo - create one from url 
                const requestData = createRequestData(queryParams);
                response = await BookingFunnelService.initBookingOptions(requestData)

                if ('error' in response) {
                    throw new Error('Error with api')
                }

                store.commit('setToken', response.boReference)
                saveUrlTokenMapping(window.location.href, response.boReference)
            }

        } else {
            console.log('init(): Initializing Option Page - if bo exist, just make a refresh call');
            // has bo, make a refresh call with alt options
            response = await BookingFunnelService.refreshBookingOptions()
            if ('error' in response) {
                throw new Error('Error with api')
            }
            saveUrlTokenMapping(window.location.href, response.boReference)

            if (checkIsPackageFlight(store.getters.getBooking)) {
                startGlobalPollingFlight(store.getters.getBooking.boReference);
            }
            if (response.status == StatusV2.PROCESSING) {
                // proccesing payment go to /payment page
                return '/payment'
            }
            if (response.status == StatusV2.SUCCESS) {
                return '/paid'
            }

        }

        try {
            await applySingleCompanyConfigOnOptionsInit()
        } catch (error) {
            console.error('[optionsStep] failed to apply single-company options config', error)
        }

        try {
            await prefillParticipantsFromLocalStorage()
        } catch (error) {
            console.error('[optionsStep] failed to prefill participants from localStorage', error)
        }

        return false
    },

    hasToBeLoggedIn: false
});

